var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 2.9165H2.2222C1.92751 2.9165 1.64489 3.03942 1.43652 3.25821C1.22815 3.47701 1.11108 3.77375 1.11108 4.08317V16.9165C1.11108 17.2259 1.22815 17.5227 1.43652 17.7415C1.64489 17.9603 1.92751 18.0832 2.2222 18.0832H17.7778C18.0724 18.0832 18.3551 17.9603 18.5634 17.7415C18.7718 17.5227 18.8889 17.2259 18.8889 16.9165V4.08317C18.8889 3.77375 18.7718 3.47701 18.5634 3.25821C18.3551 3.03942 18.0724 2.9165 17.7778 2.9165ZM12.5333 15.1315L8.58886 8.95984L5.06664 14.3732L2.56664 12.0398L3.33331 11.1123L4.83331 12.5065L8.58886 6.74317L12.5833 12.9907L16.4722 7.58317L17.4166 8.32984L12.5333 15.1315Z",
    fill: "#572148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analytics-icon.5825f3f6bed17b3200f917d05457eeac.svg";
export { ForwardRef as ReactComponent };